module.exports = __webpack_public_path__ + "static/img/zu7_2x.3f23a32.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/zu7_2x.png
// module id = h863
// module chunks = 1